export default "__VITE_ASSET__a3b25da0__"